<template>
<!--内容列表-->
  <div id="onLiveList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input @keyup.enter="getList(1)" class="allInput" placeholder="直播名称" type="text" v-model="postData.LiveName">
          </p>
          <p>
            <cander v-model="postData.LiveStartDate"  :className="'allInput'" placeholderName="开始日期"  class="d_i" style="vertical-align: middle"></cander>
            <abbr class="d_i">-</abbr>
            <cander :minDate="postData.LiveStartDate" v-model="postData.LiveEndDate" :className="'allInput'" placeholderName="结束日期"  class="d_i" style="vertical-align: middle"></cander>
          </p>

          <button @click="getList(1)" class="redButton">搜索</button>
          <button @click="newLive('new')" class="redButton">新建</button>
          
          <!-- <button @click="uploadExcel()" class="redButton">直播导入</button> -->


        </div>
        <div style="width: auto">
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable" style="width:100%;table-layout: fixed">
          <thead>
          <tr>
            <th style="width:20%">直播名称</th>
            <th style="width:15%">领域</th>
            <th style="width:5%">创建人</th>
            <th style="width:10%">直播日期</th>
            <th style="width:10%">直播时间</th>
            <th style="width:5%">讲者</th>
            <th style="width:10%">是否为轮播图</th>
            <th style="width:10%">是否显示</th>
            <th style="width:5%">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td style="width:20%" class="NoWrap" :title="item.liveName">{{item.liveName}}</td>
            <td style="width:15%" class="NoWrap" :title="item.fields">{{item.fields}}</td>
            <td style="width:5%" class="NoWrap">{{item.creator}}</td>
            <td style="width:10%" class="NoWrap">{{item.liveDate}}</td>
            <td style="width:10%" class="NoWrap">{{item.liveTime}}</td>
            <td style="width:5%" class="NoWrap">{{item.speaker}}</td>
            <td style="width:10%" class="NoWrap">
							<!-- <input v-model="item.isRotation" :id="`isShow${index}isRotation`" :disabled="item.creatorId !== userInfo.id" @change="setCarousel(item)" class="allSwitch" type="checkbox">
              <label :for="`isShow${index}isRotation`" :title="item.creatorId == userInfo.id ? '' : '只能操作本人创建的直播'"></label> -->
              {{item.isRotation ? '是' : '否'}}
						</td>
            <td style="width:10%">
							<input v-model="item.isShow" :id="`isShow${index}isShow`" :disabled="!(item.creatorId === userInfo.id || isadmin)" @change="openOrClose(item)" class="allSwitch" type="checkbox">
              <label :for="`isShow${index}isShow`" :title="item.creatorId == userInfo.id ? '' : '只能操作本人创建的直播'"></label>
              <!-- {{item.isShow ? '是' : '否'}} -->
						</td>

            <td style="width:5%"><div class="icon more iconfont icongengduo moreOperations">
              <ul>
                <li @click="newLive('view', item)">查看</li>
                <li @click="newLive('edit', item)" v-if="item.creatorId == userInfo.id || isadmin">编辑</li>
                <!-- v-if="item.creatorId == userInfo.id" -->
                <li @click="delLive(item)" v-if="item.creatorId == userInfo.id || isadmin">删除</li>
              </ul>
            </div></td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>

    <model v-if="isShowModelUpload" :buttonType="btnType" title="直播导入" :maxHeight="'80vh'" :minWidth="'600px'" v-on:on-cancel="cancelModelExcel" v-on:on-confirm="confirModelExcel">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;" class="font14">
        <div class="split_3_7 m_t_10">
          <div class="required">直播导入</div>
          <div style="white-space: nowrap">
            <!-- <input type="text" class="allInput w100 p_8 b_b" placeholder="请输入直播名称"/> -->
              <input @change="clopuploadExcel($event,2)" type="file" id="inFile1" class="coverFile" accept=".xlsx"/>
              <label style="width: 74px;height: 22px;border: none;" for="inFile1" class="redButton">
                
                <span style="line-height:22px">上传Excel</span>
  
              </label>
              <span v-if="!excelName">未上传文件</span>
              <span v-if="excelName">{{excelName}}</span>
              <!-- <div class="d_i" style="width: calc(100% - 225px);white-space: normal;">建议上传图片比例900*500</div> -->
          </div>
          
        </div>
        <div v-if="resInfo" style="margin-left:159px;color:#ee1100">{{resInfo}}</div>
      </div>

    </model>

    <model v-if="isShowModel" :buttonType="btnType" :title="modeTitle" :maxHeight="'80vh'" :minWidth="'600px'" v-on:on-cancel="cancelModel" v-on:on-confirm="confirModel">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;" class="font14">
        
        <div class="split_3_7">
          <div class="required">直播名称</div>
          <div>
            <input type="text" class="allInput w100 p_8 b_b"  style="width: 300px" v-model="modelData.liveName"  placeholder="请输入直播名称"/>
          </div>
        </div>

        <div class="split_3_7 m_t_10">
          <div class="required">直播日期</div>
          <div>
            <!-- <input type="text" class="allInput w100 p_8" placeholder="请输入直播名称"/> -->
             <cander v-model="modelData.liveDate" :className="'allInput p_8'" placeholderName="直播日期"  class="w100" style="vertical-align: middle;width: 300px"></cander>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div class="required">直播时间</div>
          <div class="forElClass">
              <!-- <el-time-picker
              is-range
              v-model="modelTime"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              format="HH:mm"
              @change="timeChange"
              style="width: 300px"
              >
            </el-time-picker> -->
              <el-time-picker
                v-model="modelTime[0]"
                format="HH:mm"
                @change="changeTime(0)"
                @click.native="controlPos(0)"
                :key="'startTime'"
                placeholder="开始时间">
              </el-time-picker>
               <el-time-picker
                v-model="modelTime[1]"
                format="HH:mm"
                @click.native="controlPos(1)"
                @change="changeTime(1)"
                :key="'endTime'"
                placeholder="结束时间">
              </el-time-picker>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div class="">讲者</div>
          <div>
            <input type="text" v-model="modelData.speaker" class="allInput w100 p_8 b_b" style="width: 300px" placeholder="请输入讲者"/>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div class="required">治疗领域</div>
          <div>
            <allSelect class="w100" :width="300" :multiple="true" v-on:on-change="changeField" :chooseData="fieldsListNew" :needReturn="'name'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.fields">
            </allSelect>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div class="">适应症</div>
          <div>
            <allSelect class="w100" :width="300" :multiple="true" :chooseData="indicationsListNew" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.indications">
            </allSelect>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div class="">品牌</div>
          <div>
            <newSelect :width="'300px'" class="d_i v_m w100" :showSearch="true" :multiple="true" :chooseData="brandList" :needReturn="'brandCode'"  v-on:selectValue="getMulBrand($event)" :placeholder="'请选择品牌'" :matchValue="'brandCN'" :showValue="'{{brandCN}}'" v-model="modelData.brandCode" :borderLine="'#e1e1e1'">
            </newSelect>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div class="required">直播链接</div>
          <div>
            <input type="text" v-model="modelData.liveUrl" style="width: 300px"  class="allInput w100 p_8 b_b" placeholder="请输入直播链接"/>
          </div>
        </div>
        <!-- TODO 录播信息 -->
        <div class="split_3_7 m_t_10">
          <div class="required">是否显示录播</div>
          <div>
          <input v-model="modelData.isShowRecordLive" style="width: 300px" id="isShowRecordLive" class="allSwitch" type="checkbox">
          <label for="isShowRecordLive"></label>
          </div>
        </div>
        <transition name = "fade">
          <div v-if="modelData.isShowRecordLive">
            <div class="split_3_7 m_t_10">
              <div>会议号</div>
              <div>
                <input type="text" v-model="modelData.meettingNo" style="width: 300px"  class="allInput w100 p_8 b_b" placeholder="请输入会议号"/>
              </div>
            </div>
            <div class="split_3_7 m_t_10">
              <div class="required">录播链接</div>
              <div>
                <input type="text" v-model="modelData.recordLiveUrl" style="width: 300px"  class="allInput w100 p_8 b_b" placeholder="请输入录播链接"/>
              </div>
            </div>
            <div class="split_3_7 m_t_10">
              <div class="required">审批编号</div>
              <div>
                <input type="text" v-model="modelData.approveNo" style="width: 300px"  class="allInput w100 p_8 b_b" placeholder="审批编号"/>
              </div>
            </div>
            <div class="split_3_7 m_t_10">
              <div>录播有效期</div>
              <div>
                <cander v-model="modelData.validDate" :className="'allInput p_8'" placeholderName="录播有效期"  class="w100" style="vertical-align: middle;width: 300px"></cander>
              </div>
            </div>
          </div>
        </transition>

        <div class="split_3_7 m_t_10">
          <div class="required">是否显示</div>
          <div>
            <!-- <input type="text" class="allInput w100 p_8 b_b" placeholder="请输入直播名称"/> -->
          <input v-model="modelData.isShow" style="width: 300px" id="isShowMobile" class="allSwitch" type="checkbox">
          <label for="isShowMobile"></label>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div class="required">是否配置为轮播图</div>
          <div>
            <!-- <input type="text" class="allInput w100 p_8 b_b" placeholder="请输入直播名称"/> -->
            <input v-model="modelData.isRotation" style="width: 300px" id="isRotation" class="allSwitch" @change="getCanOn" type="checkbox">
            <label for="isRotation"></label>
          </div>
        </div>
        <div class="split_3_7 m_t_10">
          <div :class="modelData.isRotation ? 'required' : ''">上传图片</div>
          <div style="white-space: nowrap">
            <!-- <input type="text" class="allInput w100 p_8 b_b" placeholder="请输入直播名称"/> -->
              <input @change="clopuploadImg($event,2)" type="file" id="inFile" class="coverFile" accept="image/*"/>
              <label style="width: 225px;height: 125px;" for="inFile">
                <div v-if="modelData.rotationUrl">
                  <img :src="modelData.rotationUrl" width="225" height="125" style="border-radius: 8px"/>
                </div>
                <div v-else style="margin-top: 20px">
                  <span style="color: #DCDCDC;font-size: 50px">+</span>
                </div>
              </label>
              <div class="d_i" style="width: calc(100% - 225px);white-space: normal;">建议上传图片比例900*500</div>
          </div>
        </div>

      </div>
    </model>
  </div>
</template>

<script>
import contentPreview from '../../myComponents/contentPreview'
export default {
  name: 'onLiveList',
  data () {
    return {
      brandList: [],
      token: window.sessionStorage.getItem('token'),
      baseUrl: process.env.config.baseUrl,
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      previewContentId: 0,
      doctorOpenId: '',
      addnewContentType: '',
      onSearch: false,
      newModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        LiveName: '',
        LiveStartDate: '',
        LiveEndDate: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      modelData: {
        id: 0,
        liveName: "",
        liveDate: "",
        liveStartTime: "",
        liveEndTime: "",
        speaker: "",
        fields: "",
        indications: "",
        brandCode: "",
        liveUrl: "",
        isShow: true,
        isRotation: false,
        rotationUrl: "",
        isShowRecordLive:"",
        meettingNo:"",
        recordLiveUrl:"",
        approveNo:"",
        validDate:"",
        videoId:""
        // time: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)]
      },
      originModelData: {},
      modeTitle: '',
      isShowModel: false,
      isShowModelUpload:false,
      excelName:"",
      excelUrl:"",
      resInfo:"",
      fieldsListNew: [],
      fieldsList: [],
      indicationsListNew: [],
      indicationsList: [],
      modelTime: [],
      isadmin: JSON.parse(window.localStorage.getItem('isAdmin')), // 管理员
      btnType: 0
    }
  },
  created () {
    console.log(this.userInfo, 'userInfo')
    // this.getconTypeList()
    // this.getconTypeList2()
    this.getList(1)
    this.getFieldsList()
    this.getBrandList()
    this.getIndicationsList()
  },
  methods: {
    cancelModel(){
      this.isShowModel = false
      this.getList(this.page)
    },
    changeTime(i){
      console.log(i)
      console.log(this.modelTime)
      if (i === 0){
        this.modelData.liveStartTime = this.$commonJs.returnDate(this.modelTime[i], 'HHMMSS')
      } else if (i === 1){
        this.modelData.liveEndTime = this.$commonJs.returnDate(this.modelTime[i], 'HHMMSS')
      }
    },
    controlPos(i){
      // this.$nextTick(() => {
      //   const temp = document.querySelectorAll(".el-time-panel.el-popper");
      //   console.log(temp)
      //   if (temp.length > 1){
      //     temp[1].style.top = '33%'
      //     if (i === 0){
      //       temp[1].style.left = '42%'
      //     } else {
      //       temp[1].style.left = '54%'
      //     }
      //   } else {
      //     temp[0].style.top = '33%'
      //     if (i === 0){
      //       temp[0].style.left = '42%'
      //     } else {
      //       temp[0].style.left = '54%'
      //     }
      //   }
      // });
    },
    timeChange(e){
      console.log(e)
      this.modelData.liveStartTime = this.getTime(e[0])
      this.modelData.liveEndTime = this.getTime(e[1])
      console.log(this.modelData)
    },
    getTime(time){
      let thisTime = time ? new Date(time) : new Date()
      let hour = thisTime.getHours()
      let min = thisTime.getMinutes()
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      return `${hour}:${min}`
    },
    uploadExcel(){
      this.excelName=""
      this.excelUrl=""
      this.resInfo=""
      this.isShowModelUpload=true
    },
    confirModelExcel(){
      // if(this.excelUrl=="请上传 .xlsx 文件" || this.excelUrl==""){
      //  return this.$commonJs.alertTips({
      //     type: 'error',
      //     title: '提示',
      //     content: '请检查必填项！',
      //     stayTime: 5
      //   })
      // }
      let params={
        userid:this.userInfo.id,
        excelname:this.excelUrl
      } 
      console.log("this.excelUrl:",params)
      this.$axiox.post('/api/Live/management/ImportLive', params).then(res => {
        if(res=="导入成功!"){
          this.$commonJs.alertTips({
            type: 'success',
            title: '提示',
            content: res,
            stayTime: 5
          })
          this.isShowModelUpload = false
          this.getList(1)
        }else{
          this.resInfo=res
        }
      })
    },
    cancelModelExcel(){
      this.isShowModelUpload = false
      this.getList(this.page)
    },
    clopuploadExcel (e) {
      // 上传Excel
      var file = e.target.files[0]
      this.signalUpload1(file)
    },
    async signalUpload1 (e) {
      let fileExcel = e
      this.excelUrl = await this.$commonJs.uploadFile(fileExcel, '/api/Live/management/AddLiveFile', 'formFile')
      document.getElementById('inFile1').value = ''
      if(this.excelUrl=="请上传 .xlsx 文件"){
        this.excelName=""
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传Excel',
          stayTime: 5
        })
      }else{
        this.excelName=fileExcel.name
      }
       
    },

    clopuploadImg (e) {
      // 上传图片
      var file = e.target.files[0]
      this.signalUpload(file)
    },
    async signalUpload (e) {
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        this.modelData.rotationUrl = await this.$commonJs.uploadFile(fileImg, '/api/Live/management/addthumb', 'formFile')
        document.getElementById('inFile').value = ''
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
    changeField () {
      this.modelData.indications = ''
    },
    // 获取领域
    getFieldsList () {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        this.fieldsListNew = JSON.parse(JSON.stringify(res))
        this.fieldsList = [
          {
            id: 0,
            name: '全部',
          },
          ...res
        ]
      })
    },
    // 获取适应症
    getIndicationsList (ids = []) {
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndicationsByFieldNames`, params).then(res => {
        console.log(res, 'getIndicationsList')
        if (this.modelData.fields) {
          this.indicationsListNew = JSON.parse(JSON.stringify(res))
        } else {
          this.indicationsListNew = []
        }
        this.indicationsList = [
          {
            id: 0,
            fieldId: '',
            name: '全部',
          },
          ...res
        ]
      })
    },
    getBrandList(){
      this.$axiox.get('/api/Dict/Get/brands').then( p => {
        this.brandList = p || []
      } )
    },
    getMulBrand(e){
      this.modelData.brandCode = e
    },
    unShelve(item){
      this.$axiox.get(`/api/Article/recall?articleId=${item.id}`).then( p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '下架成功',
          stayTime: 5
        })
        this.getList(1)
      } )
    },

    copyUrl (index) {
      let Url2 = document.getElementById('copyInpue' + index)
      Url2.select() // 选择对象
      document.execCommand('Copy')
    },
   getCanOn(){

   },
   setCarousel(item){
     this.newLive('edit', item)
    //  debugger
    // if (item.isRotation) {
    //   this.$axiox.get('/api/Live/management/LiveRotationIsOver').then( msg => {
    //     if (msg){
    //       this.$axiox.post(`/api/Live/management/update`, item).then( p => {
    //         this.$commonJs.alertTips({
    //           type: 'success',
    //           title: '成功',
    //           content: title,
    //           stayTime: 5
    //         })
    //         this.getList(this.page)
    //       } )
    //     } else{
    //       this.$commonJs.alertTips({
    //         type: 'error',
    //         title: '错误',
    //         content: '轮播设置已达上限',
    //         stayTime: 5
    //       })
    //     }
    //   } )
    // } else {
    //   this.$axiox.post(`/api/Live/management/update`, item).then( p => {
    //     this.$commonJs.alertTips({
    //       type: 'success',
    //       title: '成功',
    //       content: title,
    //       stayTime: 5
    //     })
    //     this.getList(this.page)
    //   })
    // }
   },
    delLive (item) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此直播？',
        successFun: msg => {
          this.$axiox.get('/api/Live/management/del/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    },
    openOrClose(item){
      this.$axiox.get('/api/Live/management/switch/' + item.id).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '操作成功',
          stayTime: 5
        })
        this.getList(this.page)
      })
    },
    returnEndTime(date){
      let newDate
      if (date){
        newDate = new Date(date)
      } else {
        newDate = new Date()
      }
      let year = newDate.getFullYear()
      let month = newDate.getMonth() + 1
      let Todate = newDate.getDate()
      let hour = newDate.getHours()
      let min = newDate.getMinutes()
      let sec = newDate.getSeconds()
      month = month < 10 ? '0' + month : month
      Todate = Todate < 10 ? '0' + Todate : Todate
      hour = 23
      min = 59
      sec = 59
      return new Date(year + '/' + month + '/' + Todate + ' ' + hour + ':' + min + ':' + sec)
    },
    newLive(method, item){
      if(method === 'new'){
        this.modeTitle = '新建直播'
        this.modelData = {
          id: 0,
          liveName: "",
          liveDate: "",
          liveStartTime: "",
          liveEndTime: "",
          speaker: "",
          fields: "",
          indications: "",
          brandCode: "",
          liveUrl: "",
          isShow: true,
          isRotation: false,
          rotationUrl: "",
          isShowRecordLive: false,
          recordLiveUrl:"",
          approveNo:"",
          validDate:""
        }
        this.modelTime = [new Date() , new Date()]
        this.btnType = 0
        this.isShowModel = true
        this.originModelData = {}
      } else if(method === 'view'){
        this.modeTitle = '查看直播'
        this.$axiox.get(`/api/Live/management/detail/${item.id}`).then( p => {
          this.modelData = p
          this.modelTime = [new Date(p.liveStartTime) , new Date(p.liveEndTime)]
          this.modelData.liveDate = this.$commonJs.returnDate(p.liveDate, 'YYMMDD1')
          this.modelData.validDate = this.$commonJs.returnDate(p.validDate, 'YYMMDD1')
          this.btnType = 3
          this.isShowModel = true
          this.originModelData = {}
        } )
      } else if(method === 'edit'){
        this.modeTitle = '编辑直播'
        this.$axiox.get(`/api/Live/management/detail/${item.id}`).then( p => {
          this.modelData = p
          // this.modelTime = [new Date(`${this.$commonJs.returnNowDate('YYMMDD')} ${p.liveStartTime}`) , new Date(`${this.$commonJs.returnNowDate('YYMMDD')} ${p.liveEndTime}`)]
          this.modelTime = [new Date(p.liveStartTime) , new Date(p.liveEndTime)]
          this.modelData.liveDate = this.$commonJs.returnDate(p.liveDate, 'YYMMDD1')
          this.modelData.validDate = this.$commonJs.returnDate(p.validDate, 'YYMMDD1')
          console.log(this.modelData)
          this.btnType = 0
          this.isShowModel = true
          this.originModelData = JSON.parse(JSON.stringify(this.modelData))
        } )
      }
    },
    cencelPreview () {
      this.coverShow = false
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl () {
      this.newModel = true
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.startdate === '') {
        delete data['startdate']
      }
      if (data.enddate === '') {
        delete data['enddate']
      }
      let url = this.$commonJs.returnQuery('/api/Live/management/list', data)
      this.$axiox.getList(url).then(msg => {
        console.log(msg)
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
      console.log(this.postData)
    },
    editList (item) {
      this.$router.push({
        name: 'editContList',
        query: {
          id: item.id,
          fromType: 'draft',
          selectContentType: 0,
          selectContentName: item.contentType
        }
      })
    },
    confirModel () {
      console.log(this.modelData)
      if (this.modelData.isRotation) {
        if(this.originModelData && this.originModelData.isRotation){
          this.upDateData()
        } else{
          let url = '/api/Live/management/LiveRotationIsOver'
          if (this.modeTitle === '编辑直播'){
            url += `?id=${this.modelData.id}`
          }
          this.$axiox.getNoRes(url).then( msg => {
            if (msg.message === 'True'){
              this.$commonJs.alertTips({
                type: 'error',
                title: '错误',
                content: '轮播设置已达上限',
                stayTime: 5
              })
              this.modelData.isRotation = false
            } else {
              this.upDateData()
            }
          } )
        }
      } else {
        this.upDateData()
      }
    },

    upDateData(){
      if (this.modeTitle === '查看直播') {
        this.isShowModel = false
      } else {
        if (new Date(this.modelTime[0]) > new Date(this.modelTime[1])){
          return this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '开始时间不得晚于结束时间',
            stayTime: 5
          })
        }
        this.modelData.liveStartTime = this.$commonJs.returnDate(this.modelTime[0], 'HHMMSS')
        this.modelData.liveEndTime = this.$commonJs.returnDate(this.modelTime[1], 'HHMMSS')
        if (this.$commonJs.checkIfEmpty(this.modelData, ['liveName','liveDate','liveStartTime','liveEndTime','fields','liveUrl'])){
          return
        }
        if (this.modelData.isShowRecordLive){
          if(!this.modelData.recordLiveUrl){
            // this.modelData.recordLiveUrl = this.modelData.liveUrl
            return this.$commonJs.alertTips({
              type: 'error',
              title: '提示',
              content: '请检查必填项！',
              stayTime: 5
            })
          } 
          if(!this.modelData.approveNo)
          {
            return this.$commonJs.alertTips({
              type: 'error',
              title: '提示',
              content: '请检查必填项！',
              stayTime: 5
            })
          }
        }
        if(!this.modelData.validDate)
        {
          var date=new Date(this.modelData.liveDate);
          date.setFullYear(date.getFullYear()+1);
          this.modelData.validDate = date.format("yyyy-MM-dd")
        }

        if (this.modelData.isRotation && !this.modelData.rotationUrl){
          return this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '轮播图直播必须上传图片',
            stayTime: 5
          })
        }
        this.modelData.liveStartTime = this.modelData.liveDate + ' ' + this.modelData.liveStartTime
        this.modelData.liveEndTime = this.modelData.liveDate + ' ' + this.modelData.liveEndTime
        let url, title

        if (this.modeTitle === '新建直播'){
          url = '/api/Live/management/add'
          title = '新建直播成功'
        } else if (this.modeTitle === '编辑直播') {
          url = '/api/Live/management/update'
          title = '编辑直播成功'
        }
        // tip 从录播url中提取video_id
        if(this.modelData.recordLiveUrl){
          var arr = this.modelData.recordLiveUrl.split('?');
          if(arr && arr.length >= 2){
            var reg = new RegExp("(^|&)videoid=([^&]*)(&|$)", "i"); //定义正则表达式 
            var ret = arr[1].match(reg);
            if(ret && ret.length > 0)
            {
              var val = ret[0].split('=')
              if(val && val.length >= 2)
              {
                this.modelData.videoId = val[1].replace('&','');
              }
            }
          }  
        }

        this.$axiox.post(url, this.modelData).then( p => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: title,
            stayTime: 5
          })
          this.isShowModel = false
          this.getList(1)
        } )
      }
    },
    // cancelModel () {
    //   this.modeTitle = ''
    //   this.isShowModel = false
    // },
    returnArticle (item) {
      this.$axiox.get(`/api/Article/ReturnArticle/${item.id}`).then(res => {
        console.log(res, 'returnArticle')
        if (res) {
          this.getList(1)
        }
      })
    }
  },
  watch: {
    "modelData.fields" (newData) {
      console.log(newData, 'modelData.fields')
      if (newData) {
        let ids = newData.split(',')
        console.log(ids, 'ids')
        this.getIndicationsList(ids)
      } else {
        this.indicationsListNew = []
      }
    },
    "modelData.isShowRecordLive" (value) {
      if(!value)
      {
        this.modelData.recordLiveUrl = ''
        this.modelData.approveNo = ''
        this.modelData.meettingNo = ''
      }
      if(value)
      {
        if(this.modelData.liveDate)
        {
          var date=new Date(this.modelData.liveDate);
          date.setFullYear(date.getFullYear()+1);
          this.modelData.validDate = date.format("yyyy-MM-dd")
        }
      }
    }
  },
  components: {
    'contentPreview': contentPreview
  }
}
</script>

<style scoped>
.forElClass >>> .el-date-editor.el-range-editor{
  width: 100%
}
.forElClass >>> .el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--time {
  width: 148px!important
}
.forElClass >>> .el-date-editor.el-range-editor.is-active{
  background-color: #fff;
}
.forElClass >>> .el-range-editor.is-active, .forElClass >>> .el-range-editor.is-active:hover {
  border-color: #DEDEDE;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.7s
}
.fade-enter, .fade-leave-to {
    opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onManagement/onLiveList.vue